import { formatTimestampDate, isPercentageOf, months, PAYMENT_RESOURCE_TYPE } from 'helpers'
import storeInfo from 'ducks/store'
import { Payment } from 'ducks/types'

export const getPayment = () => (): Payment => {
  const { payment } = storeInfo.store.getState()
  return payment
}
